import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Tab, Tabs, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

import TagManager from 'react-gtm-module';
import { useDispatch, useSelector } from 'react-redux';
import { selectProfile } from 'store/profile/selectors';
import { selectIsAuthenticated } from 'store/app/selectors';

// components
import CalculatorsList from '../../components/features/CalculatorsOnPage/CalculatorsList';
import PageTitle from '../../components/features/PageTitle';
import EducationalSites from '../../components/features/EducationalSolutions/EducationalSites';
import EducationalApps from '../../components/features/EducationalSolutions/EducationalApps';

// styles
import {
  Wrapper,
  Inner,
  TabsHeading,
  Wrapper2,
  TabButton,
  TabButtonActive,
  TabContainer,
} from './styles';

import { useEffect } from 'react';
import { actions as appActions } from '../../store/app/slice';
import { useLocation } from 'react-router-dom';
import WarningMessage from '../../components/layout/WarningMessage';
import { canonicalUrl } from 'config/canonicalUrl';

export function CalculatorsPage() {
  // locales hook
  const { t } = useTranslation();

  const isLoggedIn = useSelector(selectIsAuthenticated);
  const profileInfo = useSelector(selectProfile);

  const dispatch = useDispatch();

  // location hook
  const location = useLocation();

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);

  useEffect(() => {
    dispatch(appActions.setLocation(location.pathname));
  }, []);

  React.useEffect(() => {
    if (isLoggedIn && profileInfo?.data?.id) {
      const tagManagerArgs = {
        gtmId: process.env.REACT_APP_GTM_ID,
        dataLayer: {
          uid: profileInfo?.data?.id, //User ID. Id зарегистрированного пользователя.
        },
      };

      TagManager.initialize(tagManagerArgs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileInfo?.data?.id]);

  return (
    <>
      <Helmet>
        <title>{t(translations.calculatorsPage.seo.title)}</title>
        <meta
          name="description"
          content={t(translations.calculatorsPage.seo.description)}
        />
        <link
          rel="canonical"
          href={canonicalUrl + '/applications-and-calculators'}
        />
      </Helmet>
      <Wrapper>
        <Inner>
          <Tabs onSelect={index => setSelectedTabIndex(index)}>
            <Wrapper2>
              <TabsHeading>
                <PageTitle>{t(translations.calculatorsPage.title)}</PageTitle>
                <TabContainer>
                  <Tab>
                    {selectedTabIndex === 0 ? (
                      <TabButtonActive>Калькулятори</TabButtonActive>
                    ) : (
                      <TabButton>Калькулятори</TabButton>
                    )}
                  </Tab>
                  <Tab>
                    {selectedTabIndex === 1 ? (
                      <TabButtonActive>Додатки</TabButtonActive>
                    ) : (
                      <TabButton>Додатки</TabButton>
                    )}
                  </Tab>
                  <Tab>
                    {selectedTabIndex === 2 ? (
                      <TabButtonActive>Освітні сайти</TabButtonActive>
                    ) : (
                      <TabButton>Освітні сайти</TabButton>
                    )}
                  </Tab>
                </TabContainer>
              </TabsHeading>
            </Wrapper2>
            <TabPanel>
              <CalculatorsList type={'expanded'} />
            </TabPanel>
            <TabPanel>
              <EducationalSites />
            </TabPanel>
            <TabPanel>
              <EducationalApps />
            </TabPanel>
          </Tabs>
        </Inner>

        <WarningMessage HTML={t(translations.messages.warningMessage)} />
      </Wrapper>
    </>
  );
}
